import { apiSlice, asyncToastDisplay, i18n} from "./apiSlice";


export const dataVendorApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getDataVendors: builder.query({
      query: () => '/data_vendors',
      providesTags: (result = [], error, arg) => [
        { type: 'DataVendor', id: 'LIST' },
        ...result.map(({ slug: id }) => ({ type: 'DataVendor', id }))
      ],
    }),
    getDataVendor: builder.query({
      query: (dataVendorId) => `/data_vendors/${dataVendorId}`,
      providesTags: (result, error, arg) => [{ type: 'DataVendor', id: arg }],
    }),
    getDataVendorReferences: builder.query({
      query: () => ({ url: '/data_vendors/references' }),
      providesTags: ["DataVendorReferences"]
    }),
    createDataVendor: builder.mutation({
      query: (dataVendor) => ({
        url: 'data_vendors/',
        method: 'POST',
        body: dataVendor
      }),
      onQueryStarted: asyncToastDisplay({successMessage: i18n.t("toast.created")}),
      invalidatesTags: [{ type: 'DataVendor', id: 'LIST' }],
    }),
    updateDataVendor: builder.mutation({
      query: (dataVendor) => ({
        url: `data_vendors/${dataVendor.slug}`,
        method: 'PUT',
        body: dataVendor,
      }),
      onQueryStarted: asyncToastDisplay({successMessage: i18n.t("toast.updated")}),
      invalidatesTags: (result, error, arg) => [{ type: 'DataVendor', id: arg.slug }, 'Stream', 'DataVendorStream'],
    }),
    deleteDataVendor: builder.mutation({
      query: (dataVendorId) => ({
        url: `/data_vendors/${dataVendorId}`,
        method: 'DELETE'
      }),
      onQueryStarted: asyncToastDisplay({successMessage: i18n.t("toast.deleted")}),
      invalidatesTags: (result, error, arg) => [{ type: 'DataVendor', id: arg }],
    }),
  }),
  overrideExisting: false
})

export const {
  useGetDataVendorsQuery,
  useGetDataVendorQuery,
  useGetDataVendorReferencesQuery,
  useUpdateDataVendorMutation,
  useCreateDataVendorMutation,
  useDeleteDataVendorMutation
} = dataVendorApiSlice
